import React, { ReactNode } from "react";

export default function BoxWrapper({ children }: { children: ReactNode }) {
	return (
		<div className="w-100 bg-white rounded-sm shadow-sm mt-5 mb-3">
			{children}
		</div>
	);
}
